import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import InvestIcon from '../../../assets/invest-icon.svg';
import MyInvestorsDetailTableComponent from './my-investors-detail-modal-table.component';
import { getArticleByInvestor, getInvestorSummary } from '../../../apis/article.api';
import IntroComponent from '../../ManageArticles/components/intro.components';

function MyInvestorsDetailWrapper(props) {
  const { isOpen, onClose, investorId } = props;

  const [pagination, setPagination] = useState({
    limit: 4,
    page: 1,
    sortBy: undefined,
    sort: undefined,
    search: undefined
  });

  const params = {
    ...pagination
  };

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined)
  );

  // Query for article list
  const {
    data: investorArticlesData,
    isFetching,
    refetch
  } = useQuery({
    queryKey: ['getArticleByInvestor', investorId, filteredParams],
    queryFn: () => getArticleByInvestor(investorId, filteredParams)
  });

  // Query for investor summary
  const { data: investorSummaryData, isFetching: isSummaryFetching } = useQuery({
    queryKey: ['getInvestorSummary', investorId],
    queryFn: () => getInvestorSummary(investorId)
  });

  return (
    <div className="flex flex-col gap-6">
      <IntroComponent
        title="Investor's Article Portfolio"
        des="Browse the list of articles this investor has invested in."
        titleSize="sm"
        className="mt-5"
      />

      <div className="px-4 md:px-0 flex items-center gap-5 flex-col md:flex-row">
        <div className="bg-white p-6 rounded-[12px] border border-05-seasalt-white shadow-[0px_4px_4px_0px_#F2F3F780] w-full md:w-fit">
          <div className="flex items-center">
            <img src={InvestIcon} className="w-5 h-5" alt="" />
            <p className="font-[800] ml-[5px] text-sm">Investments breakdown</p>
          </div>
          <div className="mt-6 flex flex-wrap md:flex-nowrap gap-4">
            <div className="flex flex-col gap-2 w-full md:w-auto pr-4 border-b md:border-b-0 border-r-0 md:border-r border-[#E6E7EB]">
              <p className="text-05-growth-green-900 font-[800] text-sm">
                Total Articles invested in
              </p>
              <p className="text-2xl text-growth-green-900 font-[800] flex items-center gap-1">
                {investorSummaryData?.totalInvestedArticles || 0}
                <span className="text-sm font-[400]">
                  {'Article' + (investorSummaryData?.totalInvestedArticles > 1 ? 's' : '')}
                </span>
              </p>
            </div>
            <div className="flex flex-col gap-2 w-full md:w-auto pr-4 border-b md:border-b-0 border-[#E6E7EB]">
              <p className="text-05-growth-green-900 font-[800] text-sm">Total Seeds invested</p>
              <p className="text-2xl text-growth-green-900 font-[800] flex items-center gap-1">
                {investorSummaryData?.totalSeedInvested || 0}
                <span className="text-sm font-[400]">
                  {'Seed' + (investorSummaryData?.totalSeedInvested > 1 ? 's' : '')}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <MyInvestorsDetailTableComponent
        dataTable={
          Array.isArray(investorArticlesData?.articleInvestments)
            ? investorArticlesData.articleInvestments
            : []
        }
        totalPage={investorArticlesData?.totalPage}
        pagination={pagination}
        setPagination={setPagination}
        refetch={refetch}
        isFetching={isFetching}
      />
    </div>
  );
}

export default MyInvestorsDetailWrapper;
